import { isAxiosError } from "axios";
import { privateAxios } from "../axiosInstances";
import { useMutation } from "@tanstack/react-query";
import {
  CreateTransactionResponse,
  ValidateTransactionResponse,
} from "@ac-expo/api-types";
import { CreateTransactionForm } from "../schemas";

async function createTransaction(
  data: Omit<CreateTransactionForm, "acceptedTerms" | "address"> & {
    address: CreateTransactionForm["address"] | undefined;
  }
) {
  try {
    const res = await privateAxios.post<CreateTransactionResponse>(
      "/transactions",
      data
    );
    console.log("res.data", JSON.stringify(res.data));
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw {
        ...error,
        message: error.response?.data.message,
      };
    }

    throw error;
  }
}

export function useCreateTransaction() {
  return useMutation({
    mutationFn: createTransaction,
  });
}

export async function validateTransaction(paramsString: string) {
  try {
    const prefix = paramsString.startsWith("?") ? "" : "?";
    const { data } = await privateAxios.get<ValidateTransactionResponse>(
      `/transactions/validate${prefix}${paramsString}`
    );
    console.log("data in validateTransaction", JSON.stringify(data));
    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw { ...error, message: error.response?.data.message };
    }
    throw error;
  }
}

type ResendTransactionEmailParams = {
  email: string;
  eventId: string;
  orderReference: string;
  asAcExpo?: boolean;
};

export async function resendTransactionEmail({
  email,
  eventId,
  orderReference,
  asAcExpo = false,
}: ResendTransactionEmailParams) {
  try {
    const endpoint = asAcExpo
      ? `/transactions/ac-expo/resend-email/${eventId}`
      : `/transactions/resend-email/${eventId}`;
    const { data } = await privateAxios.post<void>(endpoint, {
      email: email,
      orderReference,
    });
    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw { ...error, message: error.response?.data.message };
    }
    throw error;
  }
}

export function useResendTransactionEmailMutation() {
  return useMutation({
    mutationFn: resendTransactionEmail,
  });
}
